<mat-card>

  <mat-card-content>
    <div class="flex flex-col w-full">

      <div class="flex flex-row" *ngIf="addFlag">
        <button mat-raised-button (click)="addPostRemediationSiteVisit()" style="background: #7ABDF3;">
          <mat-icon>add</mat-icon> Add Post Remediation Plan Visit
        </button>
      </div>

      <div class="flex flex-row w-full" *ngIf="initialSiteLength==0">
        <span>Post Remediation Plan Visits cannot be added until an initial site visit has been conducted.</span>
      </div>

      <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
        class="mat-elevation-z8">

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 10px;"></th>
          <td mat-cell *matCellDef="let visit" style="padding-left: 10px;align-items: center;">
            <div class="flex flex-row">
              <a title="Edit Follow up Site Visit" (click)="editPostRemediationVisit(visit)"
                *ngIf="complaintId != null && complaintId > 0 && complaintId==visit.complaintId ">
                <mat-icon>edit</mat-icon></a>

              <span *ngIf="complaintId != null && complaintId > 0 && isAdmin">
                <span>&nbsp;</span>
                <a (click)="removePostRemediationSiteVisit(visit)" title="Remove Follow-up Site Visit">
                  <mat-icon style="color:red;">delete</mat-icon></a>
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="complaintId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="complaintId != null && complaintId > 0">{{visit.complaintId}}</span>
            <a *ngIf="complaintId == null || complaintId == 0" (click)="gotoComplaint(visit)">
              {{visit.complaintId}}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="postRemediationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Post Remediation Plan Visit Date</th>
          <td mat-cell *matCellDef="let visit">
            {{visit.postRemediationDate}}
          </td>
        </ng-container>
        <ng-container matColumnDef="postRemediationConducted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Post Remediation Plan Visit Conducted</th>
          <td mat-cell *matCellDef="let visit">
            <div class="flex flex-row">
              <span *ngIf="visit.postRemediationConducted != null && visit.postRemediationConducted == 1">Yes</span>
              <span *ngIf="visit.postRemediationConducted == null || visit.postRemediationConducted == 0" style="color: red;">No</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="postRemediationResult">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Results/Reason</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="visit.postRemediationResult == 1 && visit.postRemediationConducted == 1">No Violations.</span>
            <span *ngIf="visit.postRemediationResult == 2 && visit.postRemediationConducted == 1">Violations observed (forward this complaint to OHA).</span>
            <span *ngIf="visit.postRemediationResult == 1 && visit.postRemediationConducted == 0">Post Remediation visit denied (forward to OHA).</span>
            <span *ngIf="visit.postRemediationResult == 2 && visit.postRemediationConducted == 0">Other (explain in comments).</span>

            <br />
            <span *ngIf="visit.postRemediationResult != null && visit.postRemediationResult != 1 && visit.postRemediationConducted == 1" style="color:red;">
                This result requires you to forward this Complaint to OHA
            </span>
            
            <span style="color:red;">{{visit.requiredVisitDate}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="comments">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Visit Notes</th>
          <td mat-cell *matCellDef="let visit">
            <div style="white-space: pre-wrap;overflow-wrap: break-word;overflow:auto">{{visit.comments}}</div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
      </table>
    </div>
  </mat-card-content>

</mat-card>